import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=a06a3c64&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=a06a3c64&prod&lang=css"
import style1 from "./FormModal.vue?vue&type=style&index=1&id=a06a3c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a3c64",
  null
  
)

export default component.exports